export enum AlertSubscriptionType {
  TRIAL_EXPIRED,
  LOCKED_FEATURE,
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/alert-subscription-type.enum.ts